import { observer } from "mobx-react-lite"

import { Vertical } from "@/components/Flex.ts"
import { Heading2 } from "@/components/Heading/Heading.tsx"
import { WarmupSnapshotsList } from "@/components/WarmupSnapshots/WarmupSnapshotsList.tsx"

import type { WarmupSnapshotsViewModel } from "@/routes/projects/warmups/WarmupSnapshotsViewModel.ts"


export const ProjectWarmupSnapshotsTab = observer((props: {
  model: WarmupSnapshotsViewModel
}) => {
  const warmupModel = props.model

  return (
    <Vertical gap="16px">
      <Heading2>Warmup Snapshots</Heading2>
      <WarmupSnapshotsList model={warmupModel} canEditProject={warmupModel.canEditProject.get()} />
    </Vertical>
  )
})